import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LogoutUser, SetAuthToken, SetCustomerId, SetLoggedIn, SetUserName } from './auth.actions';
import { AuthStateModule } from './auth.state';

@Injectable({ providedIn: 'root' })
export class AuthStateFacade {
  public loggedIn$: Observable<boolean>;
  public authToken$: Observable<string>;
  public customerId$: Observable<string>;
  public userName$: Observable<string>;

  constructor(private _store: Store) {
    this.loggedIn$ = this._store.select(AuthStateModule.loggedIn);
    this.authToken$ = this._store.select(AuthStateModule.authToken);
    this.customerId$ = this._store.select(AuthStateModule.customerId);
    this.userName$ = this._store.select(AuthStateModule.userName);
  }

  public get loggedIn(): boolean {
    return this._store.selectSnapshot(AuthStateModule.loggedIn);
  }

  public get authToken(): string {
    return this._store.selectSnapshot(AuthStateModule.authToken);
  }

  public get customerId(): string {
    return this._store.selectSnapshot(AuthStateModule.customerId);
  }

  public get userName(): string {
    return this._store.selectSnapshot(AuthStateModule.userName);
  }

  public setLoggedIn(loggedIn: boolean): Observable<void> {
    return this._store.dispatch(new SetLoggedIn({ loggedIn }));
  }

  public setAuthToken(authToken: string): Observable<void> {
    return this._store.dispatch(new SetAuthToken({ authToken }));
  }

  public setCustomerId(customerId: string): Observable<void> {
    return this._store.dispatch(new SetCustomerId({ customerId }));
  }

  public setUserName(userName: string): Observable<void> {
    return this._store.dispatch(new SetUserName({ userName }));
  }

  public logoutUser(): Observable<void> {
    return this._store.dispatch(new LogoutUser());
  }
}
